import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Linkedin, Mail } from "lucide-react";
import { ROUTES } from "@/config/routes";
import { PreloadLink } from "@/components/PreloadLink";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muted/30 border-t mt-auto">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to={ROUTES.HOME} className="text-2xl font-bold text-primary">
              VaksineTorget
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Den digitale møteplassen for bedrifter og vaksinetilbydere i Norge.
            </p>
            <p className="text-xs text-muted-foreground">
              Brobekkveien 80C<br />
              0582 OSLO
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">Snarveier</h3>
            <nav className="flex flex-col space-y-2">
              <PreloadLink
                to={ROUTES.SAVINGS_CALCULATOR}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Hvor mye kan jeg spare?
              </PreloadLink>
              <PreloadLink
                to={ROUTES.HOW_IT_WORKS}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Hvordan det fungerer
              </PreloadLink>
              <PreloadLink
                to={ROUTES.FOR_COMPANIES}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                For bedrifter
              </PreloadLink>
              <PreloadLink
                to={ROUTES.FOR_PROVIDERS}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                For tilbydere
              </PreloadLink>
              <PreloadLink
                to={ROUTES.ABOUT}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Om oss
              </PreloadLink>
              <PreloadLink
                to={ROUTES.CONTACT}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Kontakt
              </PreloadLink>
            </nav>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">Støtte</h3>
            <nav className="flex flex-col space-y-2">
              <PreloadLink
                to={ROUTES.CONTACT}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Kontakt oss
              </PreloadLink>
              <PreloadLink
                to={ROUTES.PRIVACY_TERMS}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Personvern og vilkår
              </PreloadLink>
              <a
                href="mailto:post@vaksinetorget.no"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                post@vaksinetorget.no
              </a>
            </nav>
          </div>

          {/* Social Media */}
          <div className="space-y-4 sm:col-span-2 lg:col-span-1">
            <h3 className="font-semibold text-foreground">Følg oss</h3>
            <div className="flex gap-3 md:gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="h-11 w-11 md:h-10 md:w-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors active:scale-95"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5 text-primary" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="h-11 w-11 md:h-10 md:w-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors active:scale-95"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5 text-primary" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="h-11 w-11 md:h-10 md:w-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors active:scale-95"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5 text-primary" />
              </a>
              <a
                href="mailto:post@vaksinetorget.no"
                className="h-11 w-11 md:h-10 md:w-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors active:scale-95"
                aria-label="E-post"
              >
                <Mail className="h-5 w-5 text-primary" />
              </a>
            </div>
            <p className="text-xs text-muted-foreground mt-4">
              Mandag–Fredag: 08:00–16:00
            </p>
          </div>
        </div>

        <Separator className="my-6 md:my-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left">
            © {currentYear} VaksineTorget. Alle rettigheter forbeholdt.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm text-muted-foreground">
            <PreloadLink
              to={ROUTES.PRIVACY_TERMS}
              className="hover:text-primary transition-colors"
            >
              Personvern
            </PreloadLink>
            <PreloadLink
              to={ROUTES.PRIVACY_TERMS}
              className="hover:text-primary transition-colors"
            >
              Vilkår
            </PreloadLink>
            <PreloadLink
              to={ROUTES.CONTACT}
              className="hover:text-primary transition-colors"
            >
              Kontakt
            </PreloadLink>
          </div>
        </div>
      </div>
    </footer>
  );
};
